module.exports = __webpack_public_path__ + "static/img/giver.7fb3a38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/giver.svg
// module id = c40d
// module chunks = 1